export const EMAIL_REGEX =
    /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i

export const PHONE_REGEX = /^\(?\d{2}\)?\s?\d{4,5}-?\d{4}$/
